export default __webpack_public_path__ + "static/media/assasin.150e68e4.jpg";